/**
Project: Voice Panel (c)
Title: SignOut Intereactive  
Description: Component for sign out
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/

import React, { Component } from "react";

class SignoutInteractive extends Component {
  async componentDidMount() {
    window.opener.location.reload();
    window.opener.location.replace(window.location.origin + "/signin");
    window.close();
  }

  render() {
    return <></>;
  }
}
export default SignoutInteractive;
